<template>
  <v-container id="dashboard" fluid tag="section" class="pt-0">

    <div class="my-3 white rounded-md pa-3">
      <v-row>
        <v-col cols="12" md='2'>
          <v-select-search
            hide-details
            outlined dense
            label="年份选择"
            :data='yearItems'
            @on-change="loadData"
            item-text="label"
            item-value="value"
            clearable
            multiple
            clear-icon="mdi-close-circle-outline"
            v-model='params.years'>
          </v-select-search>
        </v-col>
          <v-col cols="12" md='2'>
          <v-select
            :items="[{text: '按月份查询', value: 1}, {text: '按季度查询', value: 2}, {text: '按自定义时间', value: 3}]"
            label="查询方式"
            v-model="params.secType"
            hide-details='auto'
            outlined dense
            clear-icon="mdi-close-circle-outline"
            @change="secTypeChange"
          ></v-select>
        </v-col>

        <v-col cols="12" md='2' v-show='params.secType === 1'>
          <v-select-search
            hide-details
            outlined dense
            label="月份选择"
            :data="monthItems"
            @on-change="loadData"
            item-text="label"
            item-value="value"
            clearable
            multiple
            clear-icon="mdi-close-circle-outline"
            v-model='params.months'>
          </v-select-search>
        </v-col>
        <v-col cols="12" md='2' v-show='params.secType === 2'>
          <v-select-search
            hide-details
            outlined dense
            label="季度选择"
            :data="[{text: '第一季度', value: 1}, {text: '第二季度', value: 2}, {text: '第三季度', value: 3},{text: '第四季度', value: 4}]"
            @on-change="loadData"
            item-text="text"
            item-value="value"
            clearable
            multiple
            clear-icon="mdi-close-circle-outline"
            v-model='params.quarters'>
          </v-select-search>
        </v-col>
        <v-col cols="12" md='2' v-show='params.secType === 3'>
          <base-material-date
            hide-details
            range
            label='签订时间'
            clearable
            outlined dense
            clear-icon="mdi-close-circle-outline"
            @on-change="loadData"
            v-model="params.times"
          >
          </base-material-date>
        </v-col>
        <v-col cols="12" :md='$isMobile ? 12 : 2' class="mt-0">
          <v-btn depressed :block='$isMobile' class="px-2" dark :loading='loading' @click="loadData" color="primary">
            <v-icon size="20"  dark>mdi-magnify</v-icon>查询
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <div>
      <v-row>
        <v-col :cols="$isMobile ? 12 : 4">
          <v-card elevation="0" :loading='loading'>
            <v-card-title class="size-18">
              <v-avatar color="blue lighten-5" rounded="lg" size="26" class="mt-n1">
                <v-icon dark small color="blue">mdi-google-ads</v-icon>
              </v-avatar>&nbsp;&nbsp;数据看板</v-card-title>
            <v-card-text>
              <v-row>
                <v-col :cols="$isMobile ? 12 : 6" v-for='(item, idx) in customer' :key='idx'>
                  <v-card class="grey lighten-5" elevation="0" :href='item.href' height="100">
                    <div class="d-flex flex-no-wrap">
                      <v-avatar class="ml-3 mt-6" size="45" rounded="xl" :color="`${item.color} darken-1`" >
                        <v-icon dark>{{item.icon}}</v-icon>
                      </v-avatar>
                      <div>
                        <v-card-subtitle class="size-17 font-weight-bold pt-6 pb-2">
                          <count-to :endVal='item.value' :duration='2000'></count-to>
                        </v-card-subtitle>
                        <v-card-text class="size-13 font-weight-bold grey--text">
                          {{item.title}}
                        </v-card-text>
                      </div>
                    </div>
                  </v-card>
                </v-col>
                <v-col :cols="$isMobile ? 12 : 6" v-for='(item, i) in contract' :key='`key-${i}`'>
                  <v-card class="grey lighten-5" elevation="0" :href='item.href' height="100">
                    <div class="d-flex flex-no-wrap">
                      <v-avatar class="ml-3 mt-6" size="45" rounded="xl" :color="`${item.color} darken-1`" >
                        <v-icon dark>{{item.icon}}</v-icon>
                      </v-avatar>
                      <div>
                        <v-card-subtitle class="size-17 font-weight-bold pt-6 pb-2">
                          <count-to :endVal='item.value' :duration='2000'></count-to>
                        </v-card-subtitle>
                        <v-card-text class="size-13 font-weight-bold grey--text">
                          {{item.title}}
                        </v-card-text>
                      </div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col :cols="$isMobile ? 12 : 4">
          <v-card class="rounded-md overflow-auto" :loading='nloading' elevation="0" :height="$isMobile ? 300 : 210" v-has='"dashboard-notice-info"'>
            <v-card-title class="py-2 size-18">
              <v-avatar color="cyan lighten-5" rounded="lg" size="26" class="mt-n1">
                <v-icon dark small color="cyan">mdi-bulletin-board</v-icon>
              </v-avatar>&nbsp;&nbsp;通知公告
              <v-spacer></v-spacer>
                <v-btn class="mr-2" text dark x-small color="grey" depressed to="notice/info" v-has="'dashboard-notice-history'">
                历史
              </v-btn>
              <v-btn fab dark x-small color="primary" v-has="'dashboard-notice-add'" depressed :loading="nloading" @click="noticeModal = { show: true }">
                <v-icon dark>mdi-plus</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text v-if="notices.length >0">
              <div v-for="(item, idx) in notices" :key="idx" rounded="lg" class="my-2">
                <v-row align="center" no-gutters >
                  <v-col class="grow size-15  d-inline-block text-truncate" cols="9">
                    <v-chip label x-small class="pa-1 mr-1 mt-n1" dark :color="item.reads.filter(i => i.createUserId === $store.state.userInfo.id).length > 0 ? 'green' :'warning'">
                      {{item.reads.filter(i => i.createUserId === $store.state.userInfo.id).length > 0 ? '已读' : '未读'}}
                    </v-chip>
                    <a class="grey--text text-left pa-0" small text @click="noticeDetailModal= { show: true, data: item }">{{item.title}}</a>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col class="shrink text-right" cols="3">
                    {{item.createTime | formatDay}}
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
          </v-card>
          <v-card class="rounded-md overflow-auto mt-2" :loading='loading' elevation="0" height="210" v-has='"dashboard-discuses-add"'>
            <v-card-title class="size-18 pb-0">
              <v-avatar color="purple lighten-5" rounded="lg" size="26" class="mt-n1">
                <v-icon dark small color="purple">mdi-comment-edit-outline</v-icon>
              </v-avatar>&nbsp;&nbsp;问题纪要
              <v-spacer></v-spacer>
              <v-btn class="mr-2" text dark x-small color="grey" depressed to="discuss/info" v-has="'dashboard-discuses-add'">
                历史
              </v-btn>
              <v-btn fab dark x-small v-has='"dashboard-discuses-add"' color="primary" depressed @click="discussModal = { show: true, params: { type: 0 }}">
                <v-icon dark>mdi-plus</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text v-if="discuses.length >0">
              <div v-for="(item, idx) in discuses" :key="idx" rounded="lg" class="my-2">
                <v-row align="center" no-gutters v-has='"dashboard-discuses-add"'>
                  <v-col class="grow size-15  d-inline-block text-truncate" cols="10">
                    <v-chip label small class="mr-1 pa-1" dark color="primary">
                      {{item.createUser.name}}
                    </v-chip>
                    <a class="grey--text text-left pa-0" small text @click="discussDetailModal= { show: true, data: item }">{{item.title}}</a>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col class="shrink text-right" cols="2">
                    <v-btn v-if="item.createUserId === $store.state.userInfo.id" @click="discussFinsh(item.id)" fab x-small text depressed>
                      <v-icon color="grey" class="pa-0">mdi-check-circle-outline</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
            <v-card-text v-else>
              <div class="line-height-6 text-center size-20">暂无数据...</div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col :cols="$isMobile ? 12 : 4" v-if="$store.state.userInfo.accountType === 1">
          <v-card class="rounded-md overflow-auto" elevation="0" :height="$isMobile ? 300 : 428" :loading="ploading">
            <v-card-title class="pa-2 pt-3 size-18">
              <v-avatar color="indigo lighten-5" rounded="lg" size="26" class="mt-n1">
                <v-icon dark small color="indigo">mdi-camera-timer</v-icon>
              </v-avatar>&nbsp;&nbsp;鸭蛋待消除
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="3" v-for='(item, idx) in noSignUsers' :key='idx' class="text-center">
                  <v-avatar rounded="lg" size="50">
                    <v-img :src="item.avatar"/>
                  </v-avatar>
                  <p class="mb-0 size-13 mt-1">{{item.name}}</p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

      </v-row>
    </div>

    <div class="my-3 white rounded-md pa-3">
      <v-row justify="center">
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-row
                align="center"
                class="spacer"
                no-gutters
              >
                <v-col cols="12" class="text-left">
                  <v-avatar color="brown lighten-5" rounded="lg" size="26" class="mt-n1">
                    <v-icon dark small color="brown">mdi-credit-card-edit-outline</v-icon>
                  </v-avatar>&nbsp;&nbsp;
                  开票信息
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" md="6" v-for="(item, idx) in invoices" :key="idx">
                    <v-card class="pa-0" outlined>
                      <v-card-title class="size-17 pa-2">
                        {{item.title}}
                        <v-spacer></v-spacer>
                        <span class="size-14" v-if="item.bankCode">行号：{{item.bankCode}}</span>
                      </v-card-title>
                      <v-card-text class="pa-2">
                        <div>公&nbsp;司&nbsp;税 &nbsp;号：{{item.code}}</div>
                        <div>开户行地址：{{item.bankAddress}}</div>
                        <div>公&nbsp;司&nbsp;账 &nbsp;户：{{item.bankNumber}}</div>
                        <div>单&nbsp;位&nbsp;地 &nbsp;址：{{item.companyAddress}}</div>
                        <div>联&nbsp;系&nbsp;电 &nbsp;话：{{item.companyPhone}}</div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
    </div>

    <div class="my-3 rounded-md">
      <v-row>
       <v-col :cols="$isMobile ? 12 : 5" v-if="$store.state.userInfo.accountType !== 3">
          <v-card class="rounded-md" elevation="0" :loading='loading' height="430" v-has='"dashboard-sign-target"'>
            <v-card-title class="size-18">
              <v-avatar color="teal lighten-5" rounded="lg" size="26" class="mt-n1">
                <v-icon dark small color="teal">mdi-pencil</v-icon>
              </v-avatar>&nbsp;&nbsp;签单目标
              <v-select
                style="width: 120px;"
                hide-details
                outlined dense
                label="年份"
                :items='yearItems'
                @change="loadTarget"
                item-text="label"
                item-value="value"
                clear-icon="mdi-close-circle-outline"
                class="ml-1"
                v-model='params.target.year'
              ></v-select>
              <v-select
                style="width: 90px;"
                class="ml-1"
                hide-details
                outlined dense
                label="月份"
                :items='monthItems'
                @change="loadTarget"
                item-text="label"
                item-value="value"
                clear-icon="mdi-close-circle-outline"
                v-model='params.target.month'
              ></v-select>
            </v-card-title>
            <v-card-text v-if="targets.length > 0">
              <v-row v-for="(item, idx) in targets" :key="idx">
                <v-col cols="12" :class="idx === (targets.length-1) ?  'pb-3 pt-0' : 'py-0'">
                  <v-card-title class="size-12 px-0 pt-3 pb-0">
                    {{item.name}}
                    <span v-if="$store.state.userInfo.level && item.setType === 3">
                      <v-chip class="my-1 mx-1 pa-1" color="primary" label small>{{$store.state.userInfo.level.name}}级</v-chip>
                    </span>
                    ¥{{item.monthTarget}}
                    <v-spacer></v-spacer>
                    <span class="size-10 grey--text">(壹类:¥{{item.stateOne1SignPrice}}）</span>
                    <span class="size-10 grey--text">(一壹类:¥{{item.stateOneSignPrice}})</span>
                    <span class="primary--text">¥{{item.signPrice}}</span>
                  </v-card-title>
                  <v-progress-linear rounded :color='Number(item.ratio) | fmColor' :value="Number(item.ratio)" height="20" striped>
                    <strong>
                      <count-to :endVal='Number(item.ratio)' :duration='2000'></count-to>%
                    </strong>
                  </v-progress-linear>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text v-else>
              暂未设置目标...
            </v-card-text>
          </v-card>
        </v-col>
        <v-col :cols="$isMobile ? 12 : 5" v-else>
          <v-card class="rounded-md" elevation="0" height="330">
            <v-card-title>签单情况</v-card-title>
            <v-card-text>
              <div v-for="(dept, idx) in $store.state.userInfo.deptIdSet" :key="idx">
                <div v-for="(item, i) in deptRankings" :key="i">
                  <div v-if="item.id === dept">
                    <v-chip class="px-1" small label color="primary">{{item.name}}</v-chip>
                    <div class="my-2">绩效金额：<div class="float-right size-18">{{item.profitPrice}}</div></div>
                    <div class="my-2">签单数量：<div class="float-right size-18">{{item.signNumber}}</div></div>
                    <v-divider></v-divider>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col :cols="$isMobile ? 12 : 4" v-if="$store.state.userInfo.accountType === 1 && !$isMobile">
          <v-card class="rounded-md" elevation="0" :loading='loading' height="430" v-has='"dashboard-sign-target"'>
            <v-card-title class="size-18">
              <v-avatar color="light-green lighten-5" rounded="lg" size="26" class="mt-n1">
                <v-icon dark small color="light-green ">mdi-account-group</v-icon>
              </v-avatar>&nbsp;&nbsp;月冠军团队
              <v-spacer></v-spacer>
              <span class="size-16 grey--text">{{$moment().format('YYYY')}}/{{$moment().format('MM')}}</span>
            </v-card-title>
            <v-card-text>
              <v-card outlined v-if="deptRankings.length > 0">
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="2" class="text-center py-2">
                      <v-avatar size="35" color="amber">
                        <v-icon color="white">mdi-crown-outline</v-icon>
                      </v-avatar>
                    </v-col>
                    <v-col cols="12" md="7" class="grey--text py-1 size-18 text--darken-1 font-weight-bold">
                      <p class="mt-3">{{deptRankings[0].name}}</p>
                    </v-col>
                     <v-col cols="12" md="3" class="grey--text py-1 size-13 text--darken-1 font-weight-bold">
                      <v-chip class="mt-3" small dark color="green">本月</v-chip>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <!-- 月度销冠次数统计 -->
              <v-card elevation="0" v-if="deptMonthHeroCount.length > 0">
                <v-card-text v-for="(item, idx) in deptMonthHeroCount" :key="idx" class="py-6">
                  <div class="float-left size-15 font-weight-bold">{{item.name}}</div>
                  <div class="float-right">
                    <span class="size-10 mr-1">月度销冠</span>
                    <span :class="`${item.num > 0 ? 'green--text' : 'grey--text'} size-27 font-family-Impact`">{{item.num}}</span>
                    <span class="size-10 ml-1">次</span>
                  </div>
                </v-card-text>
              </v-card>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col :cols="$isMobile ? 12 : 3" v-if="$store.state.userInfo.accountType === 1 && !$isMobile">
          <v-card class="rounded-md" elevation="0" :loading='loading' height="430" v-has='"dashboard-sign-target"'>
            <v-card-title class="size-18">
              <v-avatar color="light-green lighten-5" rounded="lg" size="26" class="mt-n1">
                <v-icon dark small color="light-green ">mdi-account-group</v-icon>
              </v-avatar>&nbsp;&nbsp;英雄榜
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6" class="pt-1">
                  <v-card-subtitle class="red--text text-center text--accent-4 size-20 pt-0 font-weight-bold">月度榜</v-card-subtitle>
                  <v-card-text class="px-0 py-3" v-for="(item, idx) in heroList.filter((i) => i.type === 2)" :key="idx">
                    <v-card class="red lighten-5" elevation="0" rounded="pill">
                      <v-avatar size="40">
                        <v-img :src="item.avatar"/>
                      </v-avatar>
                      <span class="size-13 ml-5">{{item.name}}</span>
                    </v-card>
                  </v-card-text>
                </v-col>
                <v-col cols="12" md="6" class="pt-1">
                  <v-card-subtitle class="red--text text-center text--accent-4 size-20 pt-0 font-weight-bold">年度榜</v-card-subtitle>
                   <v-card-text class="px-0 py-3" v-for="(item, idx) in heroList.filter((i) => i.type === 1)" :key="idx">
                     <v-card class="red lighten-5" elevation="0" rounded="pill">
                      <v-avatar size="40">
                        <v-img :src="item.avatar"/>
                      </v-avatar>
                      <span class="size-13 ml-5">{{item.name}}</span>
                    </v-card>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

      </v-row>
    </div>


    <div class="rounded-md">
      <v-row>
        <v-col cols="12" md='5' v-if="!$isMobile">
          <product-view :items='products'></product-view>
        </v-col>
        <v-col :cols="$isMobile ? 12 : 7">
          <v-card class="rounded-md overflow-auto" style="position: revert;" elevation="0" :height="$isMobile ? 305 : 305" :loading="ploading">
            <v-card-title class="pa-2 pt-3 size-18" style="position: absolute;z-index: 100;background: white;width: 56%;">
              <v-avatar color="deep-orange lighten-5" rounded="lg" size="26" class="mt-n1">
                <v-icon dark small color="deep-orange">mdi-alarm-panel</v-icon>
              </v-avatar>&nbsp;&nbsp;产品报价
              <v-text-field class="ml-1 mt-0" label="在此输入关键字搜索..." dense rounded hide-details clearable @input="productInput"></v-text-field>
            </v-card-title>
            <v-card-text class="mt-13">
              <v-card  v-for="(item, i) in allProducts" outlined :key="i" class="mb-1">
                <v-card-title class="pa-1 size-14 font-weight-regular">
                  <v-chip small dark label class="pa-1" color="green">{{item.stateDic.name}}</v-chip>
                  <div class="mx-1">{{item.name}}</div>
                  <v-spacer></v-spacer>
                  <v-chip small dark label class="pa-1" color="blue accent-2">¥{{item.suggestedPrice || 0}}</v-chip>
                </v-card-title>
              </v-card>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div  v-has='"dashboard-sign-ranking"'>
      <ranking-view v-if="$store.state.userInfo.accountType !== 3" :rewardInfos="rewardInfos" :selfRankings='selfRankings' :deptRankings="deptRankings" :selfReturnRankings="selfReturnRankings"></ranking-view>
    </div>
    <!-- <v-row v-if="!$isMobile && $store.state.userInfo.accountType !== 3" v-has='"dashboard-sign-chart"'>
      <v-col cols="12">
        <v-card class="elevation-0 rounded-md text-center">
          <v-card-title>{{Number(this.$moment().format('YYYY'))}}年个人月签单额+月平均签单额走势图</v-card-title>
          <v-card-text>
            <ve-histogram :data="chartData" height='550px' :extend="chartExtend" :settings="chartSettings"></ve-histogram>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row> -->
    <check-level :item='levelModal' @on-load-data='loadData'></check-level>
    <discuss-view :item='discussModal' @on-load-data='loadData'></discuss-view>
    <discuss-detail :item='discussDetailModal'></discuss-detail>
    <notice-add :item='noticeModal' @on-load-data='getNotices()'></notice-add>
    <notice-detail :item='noticeDetailModal' @on-load-data="getNotices()"></notice-detail>
  </v-container>
</template>

<script>
  import CountTo from 'vue-count-to'
  import { statis, target } from '@/api/home.js'
  import { notices } from '@/api/notice/index.js'
  import { products } from '@/api/product/index.js'
  import { save } from '@/api/discuss/index.js'
  import { selectData2, selectMonthData } from '@/utils/tool.js'
  import VSelectSearch from '@/components/select/v-select-search.vue'
  import DiscussView from '@/views/pages/pc/discuss/info/components/Add.vue'
  import DiscussDetail from '@/views/pages/pc/discuss/info/components/ShowDetail.vue'
  import NoticeAdd from '@/views/pages/pc/notice/components/Add.vue'
  import NoticeDetail from '@/views/pages/pc/notice/components/ShowDetail.vue'
  import RankingView from './ranking/Index.vue'
  import ProductView from './product/Index.vue'
  import CheckLevel from './CheckLevel.vue'

  export default {
    name: 'Dashboard',
    components: {
      CountTo,
      NoticeAdd,
      RankingView,
      ProductView,
      VSelectSearch,
      CheckLevel,
      DiscussView,
      NoticeDetail,
      DiscussDetail
    },
    filters: {
      fmColor (val) {
        if (val <= 20) {
          return 'deep-orange'
        } else if (val > 20 && val <= 40) {
          return 'orange accent-4'
        } else if (val > 40 && val <= 60) {
          return 'orange'
        } else if (val > 60 && val <= 80) {
          return 'lime'
        } else if (val > 80 && val <= 90) {
          return 'light-green'
        } else if (val > 90) {
          return 'green'
        }
        return 'blue-grey'
      }
    },
    data() {
      this.chartSettings = {
        area: true
      }
      this.chartExtend = {
        tooltip: {
          textStyle: {
            align: 'left'
          }
        },
        series(v) {
          v.forEach(i => {
            i.barWidth = 20;
            i.itemStyle = {
              barBorderRadius: [10, 10, 10, 10],
              borderWidth: 0,
            };
            i.label = {
              color: '#666',
              show: true,
              position: 'top',
            }
          })
          return v
        }
      }
      return {
        region: [],
        loading: false,
        nloading: false,
        ploading: false,
        customer: [],
        contract: [],
        products: [],
        notices: [],
        heroList: [],
        allProducts: [],
        defProducts: [],
        noSignUsers: [],
        params: {
          secType: 1,
          months: [Number(this.$moment().format('MM'))],
          years: [Number(this.$moment().format('YYYY'))],
          userIds: [],
          quarters: [],
          times: [],
          target: {
            year: Number(this.$moment().format('YYYY')),
            month: Number(this.$moment().format('MM'))
          }
        },
        self: 86,
        dept: 61,
        company: 25,
        compare: 91,
        chartData: {
          columns: ['月份', '个人签单金额', '全公司月平均签单额', '全公司月签单人数'],
          rows: []
        },
        monthItems: selectMonthData(),
        yearItems: selectData2(),
        selfRankings: [],
        deptRankings: [],
        rewardInfos: [],
        targets: [],
        selfReturnRankings: [],
        discuses: [],
        deptMonthHeroCount: [],
        levelModal: { show: false },
        discussModal: { show: false, data: {} },
        noticeModal: { show: false, data: {} },
        noticeDetailModal: { show: false, data: {} },
        discussDetailModal: { show: false, data: {} },
        invoices: [
          {
            title: '河南耀云企业管理咨询有限公司',
            code: '91410100MA45UA4U0C',
            bankAddress: '中国民生银行股份有限公司郑州经三路支行',
            bankNumber: '157408420',
            companyAddress: '河南省郑州市高新技术产业开发区长椿路11号15幢1单元21层106号',
            companyPhone: '0371-60223826',
            bankCode: '305491030179'
          },
          {
            title: '河南迈知汇信息科技有限公司',
            code: '91410105MA46LK4K8J',
            bankAddress: '中国工商银行股份有限公司郑州财富广场支行',
            bankNumber: '1702029309200095932',
            companyAddress: '河南省郑州市金水区红专路110号25层2511室',
            companyPhone: '0371-60223826'
          },
          {
            title: '河南源点信息科技有限公司',
            code: '91410105MA47E4FM3B',
            bankAddress: '中国建设银行股份有限公司郑州经三路支行',
            bankNumber: '41050167560800000847',
            companyAddress: '河南省郑州市金水区红专路110号10层1002号',
            companyPhone: '0371-60223826',
            bankCode: '105491001599'
          },
          {
            title: '河南省迈知汇科技成果评价中心',
            code: '91410105MA47Y5N22F',
            bankAddress: '招商银行郑州未来路支行',
            bankNumber: '371907461310901',
            companyAddress: '河南省郑州市金水区红专路110号25层2509号',
            companyPhone: '0371-60223826',
            bankCode: '308491031064'
          },
          {
            title: '河南省古格知识产权代理事务所（普通合伙）',
            code: '91410105MA9FT1489W',
            bankAddress: '中国工商银行股份有限公司郑州财富广场支行',
            bankNumber: '1702029309200170325',
            companyAddress: '河南省郑州市金水区红专路110号10层1005号',
            companyPhone: '0371-60223826',
            bankCode: '102491002931'
          },
          {
            title: '源点科技（河南）有限公司',
            code: '91410103MA3X5GBM3B',
            bankAddress: '中国建设银行股份有限公司郑州大学南路支行',
            bankNumber: '41050167287400000012',
            companyAddress: '河南省郑州市金水区红专路110号10层1001号',
            companyPhone: '0371-60223826',
            bankCode: '105491001531'
          }
        ]
      }
    },
    computed: {
      getHomeLoad() {
        return this.$store.state.homeLoad
      }
    },
    watch: {
      getHomeLoad: {
        handler(newValue) {
          if (newValue) {
            console.log('重新加载了数据...')
            this.$store.dispatch('setHomeLoad', false)
          }
        }
      }
    },
    methods: {
      secTypeChange () {
        this.params.months = []
        this.params.quarters = []
        this.params.times = []
      },
      getNotices() {
        this.nloading = true
        notices({}).then(res => {
          if (res.status === 200) {
            this.notices = res.data
          }
          this.nloading = false
        })
      },
      getProducts () {
        if (this.$_has('dashboard-product-price')) {
          this.ploading = true
          products({}).then(res => {
            if (res.status === 200) {
              this.allProducts = res.data
              this.defProducts = res.data
            }
            this.ploading = false
          })
        }
      },
      productInput (pro) {
        if (pro) {
          const this_ = this
          this.allProducts = []
          this.defProducts.forEach(p => {
            if (p.name.indexOf(pro) !== -1) {
              this_.allProducts.push(p)
            }
          })
        } else {
          this.allProducts = this.defProducts
        }
      },
      loadData() {
        this.loading = true
        statis(this.params).then(res => {
          if (res.status === 200) {
            this.setData(res.data)
          }
          this.loading = false
        })
        this.getNotices()
      },
      loadTarget() {
        this.loading = true
        target(this.params.target).then(res => {
          if (res.status === 200) {
            this.targets = res.data
          }
          this.loading = false
        })
        this.getNotices()
      },
      setData (data) {
        this.setCustomer(data.customer)
        this.setContract(data.contract)
        this.products = data.products
        this.selfRankings = data.selfRankings
        this.selfReturnRankings = data.selfReturnRankings
        this.deptRankings = data.deptRankings
        this.chartData.rows = data.signAndProfits
        this.discuses = data.discuses
        this.noSignUsers = data.noSignUsers
        this.heroList = data.heroList
        this.deptMonthHeroCount = data.deptMonthHeroCount
        this.rewardInfos = data.rewardInfos
      },
      setCustomer (data) {
        this.customer = [
          {
            color: "warning",
            icon: "mdi-account-multiple",
            title: "3天内退回客户",
            value: data.willBackNumber,
            href: 'dashboard/table/customer?backPoolDay=3'
          }
        ]
      },
      setContract (data) {
        this.contract = [
          {
            color: "indigo",
            icon: "mdi-currency-usd",
            title: "待收金额",
            value: data.allPassPrice - data.returnMoney - data.endMoney,
            href: 'dashboard/table/collect'
          },
          {
            color: "purple",
            icon: "mdi-google-fit",
            title: "合同总数",
            value: data.allContrac,
            href: 'dashboard/table/contract'
          },
          {
            color: "pink",
            icon: "mdi-file-document-edit-outline",
            title: "合同总金额",
            value: data.allSignPrice,
            href: 'dashboard/table/contract'
          },
          {
            color: "cyan",
            icon: "mdi-bitcoin",
            title: "绩效总金额",
            value: data.profitPrice,
            href: 'dashboard/table/contract'
          },
          {
            color: "teal",
            icon: "mdi-calculator-variant-outline",
            title: "提成总金额",
            value: data.ratioPrice,
            href: 'dashboard/table/contract'
          }
        ]
      },
      level () {
        if (!this.$store.state.userInfo.level) {
          this.levelModal.show = true
        }
      },
      onSchedule (schedule) {
        this.scheduleJobs.push(
          {
            remark: schedule.remark,
            start_time: schedule.startTime
          }
        )
      },
      discussFinsh (id) {
        const form = { id: id, finish: 1 }
        this.$dialog.confirm({
          text: '确认完结此话题吗?',
          title: '系统提示',
          width: 340,
          actions: {
            false: { color: 'grey', text: '取消' },
            true: {
              color: 'primary',
              text: '确认',
              handle: () => new Promise(resolve => {
                save(form).then(response => {
                  const { status } = response
                  if (status === 200) {
                    this.loadData()
                    this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
                  }
                  resolve(response)
                })
              })
            }
          }
        })
      }
    },
    created() {
      this.loadTarget()
      this.loadData()
      this.getNotices()
      this.getProducts()
    }
  }
</script>

<style lang="scss">
.ranking-title{
  float: left;
}
.ranking-chip{
  float: right;
}
.back-pool {
  background:linear-gradient( to right,#00BFA5,#00BFA5,#1DE9B6)
}
.collect-monrey {
  background:linear-gradient( to right,#00BFA5,#00BFA5,#1DE9B6)
}
</style>
